import {EncodeURLComponent} from '../util'

export const searchCompanies = (data, pageNo, pageSize) => ({apis}) => {
  let params = ''
  params += EncodeURLComponent(data)
  params += `&page=${pageNo}&pageSize=${pageSize}`
  const payload = apis.searchCompanies(params).map((x) => x)
  return {
    type: 'SEARCH_DATA',
    payload,
  }
}

export const getSearchCriteria = (data) => ({apis}) => {
  const payload = apis.getSearchCriteria(data).map((x) => x)
  return {
    type: 'SEARCH_CRITERIA',
    payload,
  }
}

export const resetSearchParamsState = () => {
  return {
    type: 'RESET_SEARCH_PARAMS',
  }
}

export const onSearchResultPageChange = (data) => {
  return {
    type: 'SEARCH_RESULT_PAGE_CHANGE',
    data,
  }
}

export const selectedAccordionItem = (data) => {
  return {
    type: 'ACTIVE_ACCORDION_ITEM',
    data,
  }
}

export const clearSearchCriteria = () => {
  return {
    type: 'CLEAR_SEARCH_CRITERIA',
  }
}



// WEBPACK FOOTER //
// ./src/store/search/actions.js